import { IOption } from 'components/ui/select'

export default [
  {
    label: 'Bitte wählen',
    value: '',
  },
  {
    label: 'Handel',
    value: 'commerce',
  },
  {
    label: 'Planer/Architekt',
    value: 'architect',
  },
  {
    label: 'Verarbeiter/Fachunternehmer',
    value: 'specialist-contractor',
  },
  {
    label: 'Sonstige',
    value: 'other',
  },
] as IOption[]
